import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const FindAddress = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/find-address/components/FindAddressContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default FindAddress;
